import { render, staticRenderFns } from "./CommentTips.vue?vue&type=template&id=279975b4&scoped=true&"
import script from "./CommentTips.vue?vue&type=script&lang=js&"
export * from "./CommentTips.vue?vue&type=script&lang=js&"
import style0 from "./CommentTips.vue?vue&type=style&index=0&id=279975b4&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "279975b4",
  null
  
)

export default component.exports